<template>
    <div class="app flex-row align-items-center">
        <div class="container">
            <b-row class="justify-content-center">
                <b-col md="8">
                    <b-card-group>
                        <b-card no-body>
                            <b-card-header style="background: rgba(26, 65, 93, 1); color: white;">
                                <h1 class="my-1"><i class="fa-duotone fa-coins fa-lg fa-fw gx-logo"></i> Login</h1>
                            </b-card-header>
                            <b-card-body>
                                <b-form @submit.prevent="onSubmit">
                                    <h5 class="text-muted mb-3">Sign In to your account.</h5>

                                    <FormErrorList :message="message" :errors="errors"></FormErrorList>

                                    <b-input-group class="mb-3">
                                        <b-input-group-prepend><b-input-group-text><i class="fa-solid fa-user"></i></b-input-group-text></b-input-group-prepend>
                                        <b-form-input type="text" v-model="form.email" class="form-control" placeholder="Username" autocomplete="username email"/>
                                    </b-input-group>

                                    <b-input-group class="mb-4">
                                        <b-input-group-prepend><b-input-group-text><i class="fa-solid fa-lock"></i></b-input-group-text></b-input-group-prepend>
                                        <b-form-input type="password" v-model="form.password" class="form-control" placeholder="Password" autocomplete="current-password"></b-form-input>
                                    </b-input-group>
                                    <b-row>
                                        <b-col cols="6">
                                            <b-button type="submit" variant="primary" class="px-4" :disabled="isLoading">
                                                <div v-if="isLoading" class="spinner-border spinner-border-sm" role="status">
                                                    <span class="sr-only">Loading...</span>
                                                </div>
                                                Login
                                            </b-button>
                                        </b-col>
                                        <b-col cols="6" class="text-right">
                                            <b-button variant="link" class="px-0">Forgot password?</b-button>
                                        </b-col>
                                    </b-row>
                                </b-form>
                            </b-card-body>
                        </b-card>
                    </b-card-group>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import FormErrorList from '../components/FormErrorList';
    import {AUTH_REQUEST} from '../store/actions';

    export default {
        name: 'login',
        title: 'Login',
        components: {
            FormErrorList,
        },
        data() {
            return {
                isLoading: false,
                form: {
                    email: '',
                    password: '',
                },
                message: null,
                errors: null,
            };
        },
        methods: {
            onSubmit: function () {
                let vm = this;
                let {email, password} = this.form;

                vm.isLoading = true;

                this.$store.dispatch(AUTH_REQUEST, {email, password}).then(() => {
                    vm.isLoading = false;
                    vm.message = null;
                    vm.errors = null;
                    this.$store.commit('FORCE_CACHE_BUST');
                    if(this.$parent.lastURL) {
                        vm.$router.push(this.$parent.lastURL);
                        this.$parent.lastURL = null;
                    } else {
                        vm.$router.push({name: 'home'});
                    }
                }).catch((err) => {
                    vm.isLoading = false;
                    vm.message = null;
                    vm.errors = null;

                    if (err.response.data.errors) {
                        vm.errors = err.response.data.errors;
                    }

                    if (err.response.data.message) {
                        vm.message = err.response.data.message;
                    }
                });
            },
        },
    };
</script>

<style scoped>

</style>
